export default __webpack_public_path__ + "static/media/Badge-Icon-White.1d9e846f.svg";